import { Controller } from "@hotwired/stimulus";
import { initializeAccordion } from "../../shared";

export default class extends Controller {
  connect() {
    initializeAccordion(this.element);
  }

  async onToggle(event) {
    const closestForm = event.target.closest('form');

    const formData = new FormData(closestForm);
    formData.append('agency_email_preference[active]', event.target.checked);

    const result = await fetch(closestForm.action, {
      method: closestForm.method,
      headers: {
        "X-CSRF-Token": $.rails.csrfToken()
      },
      body: formData
    });

    if (!result.ok) {
      event.target.checked = !event.target.checked;
    }
  }
}
